import { FeathersModel } from './feathersModel'

export class SrWorker extends FeathersModel {
  static serviceName = 'sr-workers'
  workerId: number
}
